<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @row-click="clickToRowItem"
                            @new-item="newItem"
                            @delete-items="deleteItems"
                            @export="exportItems"
                            ref="gofixTable">
                            <template slot="gofix_table:submitted_at" slot-scope="row">
                                {{row.item.submitted_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>

        <b-modal 
            :no-close-on-backdrop="true" 
            id="modal-Create"
            title="Add Safety Inspection Checklist" 
            hide-footer 
            :centered="true" 
            v-model="modals.add.open">
            <template>
                <b-row class="mb-16">
                    <b-col md="12">
                        <dropdown-projects
                            required
                            show-icon-required
                            @setDefaultValue="setDefaultProject"
                            v-model="modals.add.data.project">
                        </dropdown-projects>
                        <dropdown-companies 
                            :project-id="modals.add.data.project && modals.add.data.project.id ? modals.add.data.project.id : null"
                            required
                            show-icon-required
                            v-model="modals.add.data.company">
                        </dropdown-companies>
                        <dropdown-user-duties 
                            :project-id="modals.add.data.project && modals.add.data.project.id ? modals.add.data.project.id : null"
                            :company-id="modals.add.data.company && modals.add.data.company.id ? modals.add.data.company.id : null"
                            required
                            show-icon-required
                            role-name="Contractor Supervisor"
                            :reduce="option => option.user_id"
                            v-model="modals.add.data.contractor_supervisor_id">
                        </dropdown-user-duties>
                        <dropdown-locations 
                            :project-id="modals.add.data.project && modals.add.data.project.id ? modals.add.data.project.id : null"
                            required
                            show-icon-required
                            v-model="modals.add.data.equipment">
                        </dropdown-locations>
                        <dropdown-user-duties 
                            label="Participating Inspectors"
                            :project-id="modals.add.data.project && modals.add.data.project.id ? modals.add.data.project.id : null"
                            :company-id="modals.add.data.company && modals.add.data.company.id ? modals.add.data.company.id : null"
                            :exclude-id="modals.add.data.contractor_supervisor_id"
                            :reduce="option => option.user_id"
                            v-model="modals.add.data.participating_inspector_by_id">
                        </dropdown-user-duties>
                    </b-col>
                </b-row> 
            </template>
            <b-button-group class="d-block text-right pr-4">
                <gofix-button label="APPLY" @click="save" :disabled="modals.add.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>

<script>
import { filters } from '@/_filterVar.js'
import DropdownProjects from '../elements/DropdownProjects.vue'
import DropdownLocations from '../elements/DropdownLocations.vue'
import DropdownCompanies from '../elements/DropdownCompanies.vue'
import DropdownUserDuties from '../elements/DropdownUserDuties.vue'
export default {
    name: 'SafetyInspectionChecklist',
    components: {
        DropdownProjects,
        DropdownLocations,
        DropdownCompanies,
        DropdownUserDuties
    },
    data() {
        let filter = JSON.parse(JSON.stringify(filters['safety_inspection_checklist']));
        return {
            tableConfig:{
                name: 'safety-inspection-checklist-listing',
                controls:{
                    create: this.$checkRole(this.$accessModule.safety_inspection_checklist, 'create'),
                    delete: this.$checkRole(this.$accessModule.safety_inspection_checklist, 'delete')
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                sortColumn: "created_at",
                sortDirection: "desc",
                dataSelect: {
                    status: {
                        value: [
                            {value: 'New', text: 'New'},
                            {value: 'Submitted', text: 'Submitted'},
                            {value: 'Contractor Acknowledged', text: 'Contractor Acknowledged'},
                            {value: 'Completed', text: 'Completed'},
                        ],
                        value_field: 'value',
                        text_field: 'text'
                    }
                },
            },
            tableItems: [],
            modals: {
                add: {
                    open: false,
                    loading: false,
                    data: {
                        project: null,
                        equipment: null,
                        company: null,
                        contractor_supervisor_id: null,
                        participating_inspector_by_id: null
                    },
                    options: {
                        scontracts: [],
                        equipments: [],
                        inspectors: [],
                        companies: [],
                        contractor_supervisors: [],
                    }
                }
            },
            timer: {
                save: null,
            },
        }
    },
    computed: {
    },
    watch: {
        "modals.add.data.contractor_supervisor_id": function(val) {
            if(val && val == this.modals.add.data.participating_inspector_by_id) {
                this.modals.add.data.participating_inspector_by_id = null
            }
        }, 
    },
    methods: {
        async getTableData(callback) {
            // Handle loading table data
            try {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("SafetyAppController/getSafetyInspectionChecklistItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load list of safety inspection checklist", "danger");
                        reject();
                    })
            } catch (error) {
                console.error('Error fetching table data:', error)
            }
        },  
        clickToRowItem(item) {
           this.$router.push(`/v2/safety-inspection-checklist/${item.id}`)
        },
        async newItem() {
            this.modals.add.data = {
                project: null,
                equipment: null,
                company: null,
                contractor_supervisor_id: null,
                participating_inspector_by_id: null
            };

            this.modals.add.open = true;
        },
        setDefaultProject(val) {
            this.modals.add.data.project = val
        },
        async deleteItems(callback){
            const { ids,filter, resolve,reject } = await callback();
            this.$store.dispatch("SafetyAppController/deleteSafetyInspectionItem", ids)
            .then(response => {
                resolve(this.$notificationV2('deleting', 'safe_inspection_checklist'));
            })
            .catch(err =>{
                reject(err);
            });
        },
        exportItems() {
            // Handle exporting items
            // Implement export logic (e.g., to CSV, PDF, etc.)
        },
        save() {
            if (this.timer.save) {
                clearTimeout(this.timer.save);
                this.timer.save = null;
            }
            this.timer.save = setTimeout(async () => {

                const validate_fields = [
                    { key: 'project', name: 'Project'},
                    { key: 'company', name: 'Subcontractor'},
                    { key: 'contractor_supervisor_id', name: 'Subcontractor Supervisor'},
                    { key: 'equipment', name: 'Location'},
                ]

                const is_validate = this.$validationData(validate_fields, this.modals.add.data)
                if(is_validate) return

                if(this.modals.add.loading) return;
                this.modals.add.loading = true;

                let objeClone = {
                    project_id: this.modals.add.data.project.id,
                    location_id: this.modals.add.data.equipment.location_id,
                    location: this.modals.add.data.equipment.name,
                    equipment_id: this.modals.add.data.equipment.equipment_id,
                    equipment_lift_number: this.modals.add.data.equipment.equipment_lift_number,
                    equipment_type: this.modals.add.data.equipment.equipment_type,
                    supplier_id: this.modals.add.data.company && this.modals.add.data.company.id ? this.modals.add.data.company.id : null,
                    supplier: this.modals.add.data.company && this.modals.add.data.company.name ? this.modals.add.data.company.name : null,
                    participating_inspector_by_id: this.modals.add.data.participating_inspector_by_id,
                    contractor_supervisor_id: this.modals.add.data.contractor_supervisor_id,
                };
                
                this.$store.dispatch("SafetyAppController/createSafetyInspectionItem", objeClone)
                .then(async response => {
                    this.modals.add.loading = false;
                    if(response.code && response.message) {
                        this.$alertNotification(response.message, "danger");
                        return;
                    }
                    this.modals.add.open = false;
                    await this.$router.push(`/v2/safety-inspection-checklist/${response.id}`)
                    await this.$alertNotification(this.$notificationV2('adding', 'safe_inspection_checklist'), "success");
                })
                .catch(err => {
                    this.modals.add.loading = false;
                    if( err.response.data.error && err.response.data.error.message ) {
                        this.$alertNotification(err.response.data.error.message, "danger"); 
                    }
                })

            }, 200);
        }
    },
    created() {
        // Component lifecycle hook for initialization
    }
}
</script>

<style scoped>
.safety-inspection-checklist {
    padding: 20px;
}
.tooltip {
    max-width: 400px;
}
</style>